import { InjectionToken } from '@angular/core';

import { ProcessingServiceConfig } from '@relevance/angular-core';

/**
 * Interface for the utilities service configuration.
 */
export interface UtilitiesModuleConfig {
  processingConfig?: ProcessingServiceConfig;
}

/**
 * This injection token can be used to inject the query API configuration.
 */
export const UTILS_CONFIG = new InjectionToken<UtilitiesModuleConfig>('utilities.config');
